import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  requestToGetList: false,
  apiErrorMessage: "",
  eventsList: [],
};

export const CTDisableEventsSlice = createSlice({
  name: "ctDisabledEvents",
  initialState,
  reducers: {
    /**
     * Reducer to handle disabled events.
     * @param {Object} state - Current state.
     */
    requestToGetList: (state) => {
      state.requestToGetList = true;
    },
    /**
     * Reducer to handle disabled events api failed.
     * @param {Object} state - Current state.
     */
    failedToGetList: (state, action) => {
      state.apiErrorMessage = action.payload;
    },
    /**
     * Reducer to save events to state.
     * @param {Object} state - Current state.
     * @param {Object} action - Action object containing user details payload.
     */
    requestToSaveList: (state, action) => {
      state.eventsList = action.payload;
    },
  },
});

export default CTDisableEventsSlice.reducer;
export const { requestToGetList, failedToGetList, requestToSaveList } = CTDisableEventsSlice.actions;
